module.exports = __webpack_public_path__ + "static/media/Sanchi.8155afc0.png";